import { observable, action, computed } from 'mobx';
import moment from 'moment';
import {api} from "../services";

const en = require('date-fns/locale/en');
const it = require('date-fns/locale/it');
const de = require('date-fns/locale/de');

class CommonStore {
  @observable
  longDateFormat;
  @observable dealer;
  @observable dealersSummary;

  @observable
  selectedDealers = [];

  @action
  setLongDateFormat(longDateFormat) {
    /**
     * L:"MM/DD/YYYY"
     * LL:"MMMM D, YYYY"
     * LLL:"MMMM D, YYYY h:mm A"
     * LLLL:"dddd, MMMM D, YYYY h:mm A"
     * LT:"h:mm A"
     * LTS:"h:mm:ss A"
     */
    this.longDateFormat = longDateFormat;
  }

  @computed
  get dateFnsLocale() {

    if (moment.locale() === 'en') {

      return en;
    } else if (moment.locale() === 'de') {

      return de;
    } else {

      return it;
    }
  }

  @action setDealer(dealer) {
    this.dealer = dealer;
  }

  @action setDealersSummary(dealersSummary) {
    this.dealersSummary = dealersSummary;
  }

  @action async loadDealersSummary() {
    await api('get dealer vehicle summary', this.selectedDealers).then(dealersSummary => {
      this.setDealersSummary(dealersSummary);
    });
  }

  @action setSelectedDealers(dealers) {
    this.selectedDealers = dealers;
  }

  @computed
  get momentLocale() {
    return moment.locale();
  }
}

export default new CommonStore();
